<div
  class="component-container text-cool-grey h-full flex flex-col justify-center items-center">
  <div class="forgot-password-form-container md:w-[80%] w-full p-[4rem]">
    <div class="heading font-bold font-poppins  mb-[2.4rem] text-center">
      Forgot your Password?
    </div>
    <div class="message font-work-sans font-normal mb-[2.4rem] text-center">
      Please enter your username. You will receive a link to generate new password via email.
    </div>
    <form>
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['username']"
        [parentFormGroup]="form"
        controlName="username"
        label="Username"
        placeholder="Username"
        type="small"
        inputRestriction="noUpperCaseAlphabets"
        tooltipText="If you don't receive an email, please confirm with your coach that you are entering the correct username."
      />
      <div class="cta mt-[1rem]">
        <app-primary-button
          (handleClick)="forgot()"
          [isDisabled]="forgotPasswordSuccess"
          [isLoading]="loading"
          class="action-panel"
          type="small"
        >
          {{ buttonLabel }}
        </app-primary-button>
        <div
          class="timer-container flex flex-row justify-center items-end"
        >
          <app-timer
            (handleTimerComplete)="handleCounterComplete()"
            *ngIf="forgotPasswordSuccess"
            [timerDuration]="timerValue"
          />
        </div>
      </div>
    </form>
  </div>
</div>
